import React from 'react';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

class Filter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            select: 'all',
        };

        this.onChangeRadioBtn = this.onChangeRadioBtn.bind(this);
    }

    onChangeRadioBtn(e, value) {
        this.setState({
            select: value,
        }, () => {
            this.props.changeFilter(value);
        });
    }

    render() {
        const { select } = this.state;

        return (
              <div className='paper-block margin-10'>
                  <span className='name-block absolute small-name'>Filter areas</span>
                  <RadioButtonGroup onChange={this.onChangeRadioBtn} name="filter-areas" defaultSelected={select} valueSelected={select}>
                      <RadioButton
                          value="all"
                          label="All"
                      />
                      <RadioButton
                          value="noPorts"
                          label="No ports"
                      />
                      <RadioButton
                          value="noMainPorts"
                          label="No main ports"
                      />
                  </RadioButtonGroup>
              </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/FilterAreas/Filter.jsx